import {
  ref,
  toRef,
} from "vue";

import UtilsAPI from "./UtilsAPI";

import {
  cloneDeep,
  concat,
  forEach,
  sortBy,
  values,
} from "lodash-es";

export default function ColumnsAPI(props) {
  const columns = toRef(props, "columns");

  const columnsPropsAndFromAPI = ref([]);
  const sortingFromColumns = ref([]);

  const {
    changeSnaKeCaseToCamelCase,
    checkPermissionAndContextType,
  } = UtilsAPI();

  const updateColumnsFromAPI = configForCurrentTable => {
    const COLUMNS_FROM_API = configForCurrentTable?.columns || [];
    const COLUMNS_OBJ = {};
    const SORTING_FROM_COLUMNS = [];
    forEach(concat(cloneDeep(columns.value), COLUMNS_FROM_API), column => {
      const COLUMN_CAMEL_CASE = changeSnaKeCaseToCamelCase({ obj: column, prefix: "tcc" });

      if (!checkPermissionAndContextType(COLUMN_CAMEL_CASE)) {
        return;
      }
      if (!COLUMN_CAMEL_CASE.slot) {
        COLUMN_CAMEL_CASE.slot = "rowDefault";
      }
      COLUMNS_OBJ[COLUMN_CAMEL_CASE.id] = COLUMN_CAMEL_CASE;
      const sortingDefault = COLUMN_CAMEL_CASE.sortingDefault;
      if (COLUMN_CAMEL_CASE.sortId) {
        if (sortingDefault === "asc") {
          SORTING_FROM_COLUMNS.push(COLUMN_CAMEL_CASE.sortId);
        } else if (sortingDefault === "desc") {
          SORTING_FROM_COLUMNS.push(`-${ COLUMN_CAMEL_CASE.sortId }`);
        }
      }
    });
    sortingFromColumns.value = SORTING_FROM_COLUMNS;
    columnsPropsAndFromAPI.value = sortBy(values(COLUMNS_OBJ), ["priority"]);
  };

  return {
    columnsPropsAndFromAPI,
    sortingFromColumns,
    updateColumnsFromAPI,
  };
}
